import { Data, List, Misc, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from "../../../../App/Models/NotificationDuration";
import { AppService, Types } from '../../../DomainTypes';
import PRPRate from '../../../Models/Catalogue/Pipeline/PRPRate';
import PRPRatePagedLookupCriteria from '../../../Models/Catalogue/Pipeline/Lookups/PRPRatePagedLookupCriteria';

@NeoModel
export default class PRPRateVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        protected pipelinesApiClient = AppService.get(Types.Domain.ApiClients.CataloguePipeline),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {

        super(taskRunner);
        this.autoDispose(this.criteria.onAnyPropertyChanged(() => this.pageManager.refreshData()));
    }

    public PRPRateList = new List(PRPRate);
    public criteria = new PRPRatePagedLookupCriteria();

    public pageManager = new Data.PageManager(this.criteria, PRPRate, this.pipelinesApiClient.getPRPRateLookupsPaged, {
        pageSize: 15,
        initialTaskRunner: this.taskRunner,
        fetchInitial: true,
        allowSort: true,
        sortBy: 'prpDate',
        sortAscending: false, 
    });

    public newPRPRate() {
        this.pageManager.data.addNew();
    }

    public savePRPRates() {
        this.taskRunner.run(async () => {
            const response = await this.pipelinesApiClient.savePRPRates(this.pageManager.data.toJSArray())
            this.pageManager.data.update(response.data);
            this.notifications.addSuccess("Save Successful", "PRP Rates were saved successfully.", NotificationDuration.Standard);
            this.pageManager.refreshData();
        });
    }

    public searchImmediate() {
        // TODO: this.autoRunner.fireImmediate();
    }
}